// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (callstatus-edit e callstatus-list)

import { Injectable } from '@angular/core';
import { Callstatus } from './callstatus.model';
import { Subject } from 'rxjs';

@Injectable()
export class CallstatusService {
  private callstatus: Callstatus[] = [];
  callstatusChanged = new Subject<Callstatus[]>();
  callstatusEditMode = new Subject<number>();
  callstatuscountChanged = new Subject<string>();
  private callstatuscount: string = '';

  constructor(
  ) { }

  ngOnInit() {
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getCallstatus() {
    return this.callstatus;
  }
  getCallstatuscount() {
    return this.callstatuscount;
  }
  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setCallstatus(callstatus: Callstatus[]) {
    if (callstatus !== null) {
      this.callstatus = callstatus;
      if (this.callstatus) this.callstatusChanged.next(this.callstatus.slice()); else this.callstatusChanged.next([])
    }
  }
  setCallstatuscount(callstatuscount: string) {
    if (callstatuscount !== null) {
      this.callstatuscount = callstatuscount;
      this.callstatuscountChanged.next(this.callstatuscount.slice());
    }
  }
}
